var l = 'data-section-id';
function f(e, t) {
  (this.container = w(e)),
    (this.id = e.getAttribute(l)),
    (this.extensions = []),
    Object.assign(this, m(t)),
    this.onLoad();
}
f.prototype = {
  onLoad: Function.prototype,
  onUnload: Function.prototype,
  onSelect: Function.prototype,
  onDeselect: Function.prototype,
  onBlockSelect: Function.prototype,
  onBlockDeselect: Function.prototype,
  extend: function (t) {
    this.extensions.push(t);
    var n = Object.assign({}, t);
    delete n.init, Object.assign(this, n), typeof t.init == 'function' && t.init.apply(this);
  },
};
function w(e) {
  if (!(e instanceof Element))
    throw new TypeError(
      'Theme Sections: Attempted to load section. The section container provided is not a DOM element.'
    );
  if (e.getAttribute(l) === null)
    throw new Error(
      'Theme Sections: The section container provided does not have an id assigned to the ' + l + ' attribute.'
    );
  return e;
}
function m(e) {
  if ((typeof e < 'u' && typeof e != 'object') || e === null)
    throw new TypeError('Theme Sections: The properties object provided is not a valid');
  return e;
}
typeof Object.assign != 'function' &&
  Object.defineProperty(Object, 'assign', {
    value: function (t) {
      if (t == null) throw new TypeError('Cannot convert undefined or null to object');
      for (var n = Object(t), o = 1; o < arguments.length; o++) {
        var i = arguments[o];
        if (i != null) for (var c in i) Object.prototype.hasOwnProperty.call(i, c) && (n[c] = i[c]);
      }
      return n;
    },
    writable: !0,
    configurable: !0,
  });
var a = 'data-section-type',
  h = 'data-section-id';
window.Shopify = window.Shopify || {};
window.Shopify.theme = window.Shopify.theme || {};
window.Shopify.theme.sections = window.Shopify.theme.sections || {};
var d = (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
  r = (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
function S(e, t) {
  if (typeof e != 'string')
    throw new TypeError(
      'Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered'
    );
  if (typeof d[e] < 'u')
    throw new Error(
      'Theme Sections: A section of type "' +
        e +
        '" has already been registered. You cannot register the same section type twice'
    );
  function n(o) {
    f.call(this, o, t);
  }
  return (n.constructor = f), (n.prototype = Object.create(f.prototype)), (n.prototype.type = e), (d[e] = n);
}
function v(e, t) {
  (e = y(e)),
    typeof t > 'u' && (t = document.querySelectorAll('[' + a + ']')),
    (t = g(t)),
    e.forEach(function (n) {
      var o = d[n];
      typeof o > 'u' ||
        (t = t.filter(function (i) {
          return T(i) || i.getAttribute(a) === null ? !1 : i.getAttribute(a) !== n ? !0 : (r.push(new o(i)), !1);
        }));
    });
}
function b(e) {
  var t = p(e);
  t.forEach(function (n) {
    var o = r
      .map(function (i) {
        return i.id;
      })
      .indexOf(n.id);
    r.splice(o, 1), n.onUnload();
  });
}
function p(e) {
  var t = [];
  if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var n = e[0];
  if (e instanceof Element || n instanceof Element) {
    var o = g(e);
    o.forEach(function (c) {
      t = t.concat(
        r.filter(function (u) {
          return u.container === c;
        })
      );
    });
  } else if (typeof e == 'string' || typeof n == 'string') {
    var i = y(e);
    i.forEach(function (c) {
      t = t.concat(
        r.filter(function (u) {
          return u.type === c;
        })
      );
    });
  }
  return t;
}
function s(e) {
  for (var t, n = 0; n < r.length; n++)
    if (r[n].id === e) {
      t = r[n];
      break;
    }
  return t;
}
function T(e) {
  return p(e).length > 0;
}
function y(e) {
  return (
    e === '*'
      ? (e = Object.keys(d))
      : typeof e == 'string'
        ? (e = [e])
        : e.constructor === f
          ? (e = [e.prototype.type])
          : Array.isArray(e) &&
            e[0].constructor === f &&
            (e = e.map(function (t) {
              return t.prototype.type;
            })),
    (e = e.map(function (t) {
      return t.toLowerCase();
    })),
    e
  );
}
function g(e) {
  return (
    NodeList.prototype.isPrototypeOf(e) && e.length > 0
      ? (e = Array.prototype.slice.call(e))
      : NodeList.prototype.isPrototypeOf(e) && e.length === 0
        ? (e = [])
        : e === null
          ? (e = [])
          : !Array.isArray(e) && e instanceof Element && (e = [e]),
    e
  );
}
window.Shopify.designMode &&
  (document.addEventListener('shopify:section:load', function (e) {
    var t = e.detail.sectionId,
      n = e.target.querySelector('[' + h + '="' + t + '"]');
    n !== null && v(n.getAttribute(a), n);
  }),
  document.addEventListener('shopify:section:unload', function (e) {
    var t = e.detail.sectionId,
      n = e.target.querySelector('[' + h + '="' + t + '"]'),
      o = p(n)[0];
    typeof o == 'object' && b(n);
  }),
  document.addEventListener('shopify:section:select', function (e) {
    var t = s(e.detail.sectionId);
    typeof t == 'object' && t.onSelect(e);
  }),
  document.addEventListener('shopify:section:deselect', function (e) {
    var t = s(e.detail.sectionId);
    typeof t == 'object' && t.onDeselect(e);
  }),
  document.addEventListener('shopify:block:select', function (e) {
    var t = s(e.detail.sectionId);
    typeof t == 'object' && t.onBlockSelect(e);
  }),
  document.addEventListener('shopify:block:deselect', function (e) {
    var t = s(e.detail.sectionId);
    typeof t == 'object' && t.onBlockDeselect(e);
  }));
export {v as l, S as r, b as u};
